import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { styled } from '@uhg-abyss/web/tools/styled';
import { PageLayout } from '@src/common/PageLayout';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { StateSelect } from '../../../../Address/Inputs/StateSelect';
import { LicenseType } from '../LicenseType';
import { LicenseNumber } from '../LicenseNumber';
import { AddLicenseServicing } from '../AddLicenseServicing';

const AlignInput = styled('div', {
  width: '90%',
  marginBottom: '4%',
});

const RemoveIcon = styled('span', {
  fontSize: 'initial',
  fontWeight: 'bold',
  marginRight: '25px',
  cursor: 'pointer',
  color: ' $info1',
  bottom: '5%',
});

const AlignRemove = styled('span', {
  position: 'absolute',
  marginTop: '30px',
});
const AddLic = styled('span', {
  position: 'absolute',
  marginTop: '30px',
  fontSize: 'initial',
  fontWeight: 'bold',
  float: 'right',
  marginRight: '70px',
  cursor: 'pointer',
  color: ' $info1',
});
const AlignRemoveText = styled('span', {
  marginLeft: '2px',
  verticalAlign: 'text-bottom',
});

const MIN_LICENSE = 1;
export const LicenseServicing = ({
  index,
  licenseCount,
  handleRemoveLicense,
  handleAddLicense,
}) => {
  const LC = licenseCount - 1;
  return (
    <PageLayout>
      <div id="attest-inputs">
        <Grid>
          <Grid.Col span="20%">
            <AlignInput>
              <LicenseType
                id={`license${index}-type`}
                model={`practiceInformation.medLicense[${index}].licenseType`}
                label="License Type"
                required
              />
            </AlignInput>
          </Grid.Col>
          <Grid.Col span="20%">
            <AlignInput>
              <LicenseNumber
                id={`license${index}-number`}
                model={`practiceInformation.medLicense[${index}].licenseNumber`}
                label="License Number"
                required
              />
            </AlignInput>
          </Grid.Col>
          <Grid.Col span="20%">
            <AlignInput>
              <StateSelect
                id={`license${index}-state-select`}
                model={`practiceInformation.medLicense[${index}].state`}
                required
              />
            </AlignInput>
          </Grid.Col>
          <Grid.Col span="10%">
            {licenseCount > MIN_LICENSE && (
              <AlignRemove>
                <RemoveIcon
                  id="license-addRemove-button"
                  onClick={handleRemoveLicense}
                >
                  <IconSymbol icon="delete" size="18px" />
                  <AlignRemoveText>Remove</AlignRemoveText>
                </RemoveIcon>
              </AlignRemove>
            )}
          </Grid.Col>
          <Grid.Col span="20%">
            {index === LC && (
              <AddLic>
                <AddLicenseServicing
                  licenseCount={licenseCount}
                  handleAddNewLicense={handleAddLicense}
                />
              </AddLic>
            )}
          </Grid.Col>
        </Grid>
      </div>
    </PageLayout>
  );
};

LicenseServicing.propTypes = {
  index: PropTypes.number.isRequired,
  licenseCount: PropTypes.number.isRequired,
  handleRemoveLicense: PropTypes.func.isRequired,
  handleAddLicense: PropTypes.func.isRequired,
};
